module.exports = __webpack_public_path__ + "media/images/illustration-users-778acde1.svg";